export default {"src":"/_next/static/image/src/images/onboarding/confetti.ae5c560bf5c98e1b565c1f596962358f.svg","height":900,"width":1440};